<template>
  <div class="page">
    <SplashBackground/>
    <div class="center">
      <FormContainer header="OAO Test Driver">
        <!-- use slot -->
        <template v-if="!this.api_err" #form-content>
          <div class="form-header">
            Create Route for Initial Customer & Account Information
          </div>
          <div class="v-spacer-20"/>
          <div>
            Required fields are indicated by an asterisk (<span class="fhb-red"><strong>*</strong></span>)
          </div>
          <form id="create-funding-form" @submit.prevent="submitFirstPage">
            <table>
              <tr>
                <td>primary_first_name <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_first_name" type="text" v-model="this.funding_data.primary.first_name"/></td>
              </tr>
              <tr>
                <td>primary_last_name <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_last_name" type="text" v-model="this.funding_data.primary.last_name"/></td>
              </tr>
              <tr>
                <td>primary_middle_name</td>
                <td><input id="primary_middle_name" type="text" v-model="this.funding_data.primary.middle_name"/></td>
              </tr>
              <tr>
                <td>primary_email <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_email" type="text" v-model="this.funding_data.primary.email_address"/></td>
              </tr>
              <tr>
                <td>primary_birthdate <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_birthdate" type="text" v-model="this.funding_data.primary.birthdate"/></td>
              </tr>
              <tr>
                <td>primary_mothers_maiden_name</td>
                <td><input id="primary_mothers_maiden_name" type="text" v-model="this.funding_data.primary.mothers_maiden_name"/></td>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>primary_employment_status <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_employment_status" type="text" v-model="this.funding_data.primary.employment_state"/></td>
              </tr>
              <tr>
                <td>primary_occupation <span class="optional-text">(optional)</span></td>
                <td><input id="primary_occupation" type="text" v-model="this.funding_data.primary.occupation"/></td>
              </tr>
              <tr>
                <td>primary_account_purpose <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_account_purpose" type="text" v-model="this.funding_data.primary.account_purpose"/></td>
              </tr>
              <tr>
                <td>primary_wealth_source <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_wealth_source" type="text" v-model="this.funding_data.primary.wealth_source"/></td>
              </tr>
              <tr>
                <td>primary_mobile_phone <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_mobile_phone" type="text" v-model="this.funding_data.primary.mobile_phone"/></td>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>primary_address_line_1 <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_address_line_1" type="text" v-model="this.funding_data.primary.address.address_line_1"/></td>
              </tr>
              <tr>
                <td>primary_address_line_2</td>
                <td><input id="primary_address_line_2" type="text" v-model="this.funding_data.primary.address.address_line_2"/></td>
              </tr>
              <tr>
                <td>primary_city <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_city" type="text" v-model="this.funding_data.primary.address.city"/></td>
              </tr>
              <tr>
                <td>primary_zip <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_zip" type="text" v-model="this.funding_data.primary.address.zip"/></td>
              </tr>
              <tr>
                <td>primary_state <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_state" type="text" v-model="this.funding_data.primary.address.state"/></td>
              </tr>
              <tr>
                <td class="note" colspan="2">Note: Zipcode must be a real zipcode that correctly matches the city and state.</td>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>primary_mailing_address_line_1</td>
                <td><input id="primary_mailing_address_line_1" type="text" v-model="this.funding_data.primary.mailing_address.mailing_address_line_1"/></td>
              </tr>
              <tr>
                <td>primary_mailing_address_line_2</td>
                <td><input id="primary_mailing_address_line_2" type="text" v-model="this.funding_data.primary.mailing_address.mailing_address_line_2"/></td>
              </tr>
              <tr>
                <td>primary_mailing_city</td>
                <td><input id="primary_mailing_city" type="text" v-model="this.funding_data.primary.mailing_address.mailing_city"/></td>
              </tr>
              <tr>
                <td>primary_mailing_zip</td>
                <td><input id="primary_mailing_zip" type="text" v-model="this.funding_data.primary.mailing_address.mailing_zip"/></td>
              </tr>
              <tr>
                <td>primary_mailing_state</td>
                <td><input id="primary_mailing_state" type="text" v-model="this.funding_data.primary.mailing_address.mailing_state"/></td>
              </tr>
              <tr>
                <td class="note" colspan="2">Note: Zipcode must be a real zipcode that correctly matches the city and state.</td>
              </tr>
              <tr>
                <button type="button" class="next-button" title="copy primary to mailing" @click="copyPrimaryToMailing()">
                  Copy Primary Address to Mailing
                </button>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>primary_identification_type <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_identification_type" type="text" v-model="this.funding_data.primary.identification.type"/></td>
              </tr>
              <tr>
                <td class="note" colspan="2">Note: ID Type must be one of the following: ["drivers_license", "state_id_card", "passport"]</td>
              </tr>
              <tr>
                <td>primary_identification_location <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_identification_location" type="text" v-model="this.funding_data.primary.identification.location"/></td>
              </tr>
              <tr>
                <td>primary_identification_issused_date</td>
                <td><input id="primary_identification_issused_date" type="text" v-model="this.funding_data.primary.identification.issued_date"/></td>
              </tr>
              <tr>
                <td>primary_identification_expiration_date <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_identification_expiration_date" type="text" v-model="this.funding_data.primary.identification.expiration_date"/></td>
              </tr>
              <tr>
                <td>primary_identification_number <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_identification_number" type="text" v-model="this.funding_data.primary.identification.number"/></td>
              </tr>
              <tr>
                <td>primary_ssn <span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="primary_ssn" type="text" v-model="this.funding_data.primary.ssn"/></td>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>unstructured_vars<span class="fhb-red"><strong>*</strong></span></td>
                <td><input id="unstructured_vars" type="text" v-model="this.funding_data.unstructured_vars"/></td>
              </tr>
              <div class="v-spacer-20"/>
              <tr>
                <td>is_joint</td>
                <td><input class="checkbox" id="is_joint" type="checkbox" v-model="this.funding_data.is_joint"/><label for="is_joint">Yes</label></td>
              </tr>
              <template v-if="this.funding_data.is_joint">
                <div class="v-spacer-20"/>
                <tr>
                  <td>joint_first_name</td>
                  <td><input id="joint_first_name" type="text" v-model="this.funding_data.joint.first_name"/></td>
                </tr>
                <tr>
                  <td>joint_last_name</td>
                  <td><input id="joint_last_name" type="text" v-model="this.funding_data.joint.last_name"/></td>
                </tr>
                <tr>
                  <td>joint_middle_name</td>
                  <td><input id="joint_middle_name" type="text" v-model="this.funding_data.joint.middle_name"/></td>
                </tr>
                <tr>
                  <td>joint_email</td>
                  <td><input id="joint_email" type="text" v-model="this.funding_data.joint.email_address"/></td>
                </tr>
                <tr>
                  <td>joint_birthdate</td>
                  <td><input id="joint_birthdate" type="text" v-model="this.funding_data.joint.birthdate"/></td>
                </tr>
                <tr>
                  <td>joint_mothers_maiden_name</td>
                  <td><input id="joint_mothers_maiden_name" type="text" v-model="this.funding_data.joint.mothers_maiden_name"/></td>
                </tr>
                <div class="v-spacer-20"/>
                <tr>
                  <td>joint_employment_status</td>
                  <td><input id="joint_employment_status" type="text" v-model="this.funding_data.joint.employment_state"/></td>
                </tr>
                <tr>
                  <td>joint_occupation <span class="optional-text">(optional)</span></td>
                  <td><input id="joint_occupation" type="text" v-model="this.funding_data.joint.occupation"/></td>
                </tr>
                <tr>
                  <td>joint_account_purpose</td>
                  <td><input id="joint_account_purpose" type="text" v-model="this.funding_data.joint.account_purpose"/></td>
                </tr>
                <tr>
                  <td>joint_wealth_source</td>
                  <td><input id="joint_wealth_source" type="text" v-model="this.funding_data.joint.wealth_source"/></td>
                </tr>
                <tr>
                  <td>joint_mobile_phone</td>
                  <td><input id="joint_mobile_phone" type="text" v-model="this.funding_data.joint.mobile_phone"/></td>
                </tr>
                <div class="v-spacer-20"/>
                <tr>
                  <td>joint_address_line_1</td>
                  <td><input id="joint_address_line_1" type="text" v-model="this.funding_data.joint.address.address_line_1"/></td>
                </tr>
                <tr>
                  <td>joint_address_line_2</td>
                  <td><input id="joint_address_line_2" type="text" v-model="this.funding_data.joint.address.address_line_2"/></td>
                </tr>
                <tr>
                  <td>joint_city</td>
                  <td><input id="joint_city" type="text" v-model="this.funding_data.joint.address.city"/></td>
                </tr>
                <tr>
                  <td>joint_zip</td>
                  <td><input id="joint_zip" type="text" v-model="this.funding_data.joint.address.zip"/></td>
                </tr>
                <tr>
                  <td>joint_state</td>
                  <td><input id="joint_state" type="text" v-model="this.funding_data.joint.address.state"/></td>
                </tr>
                <tr>
                  <td class="note" colspan="2">Note: Zipcode must be a real zipcode that correctly matches the city and state.</td>
                </tr>
                <div class="v-spacer-20"/>
                <tr>
                  <td>joint_mailing_address_line_1</td>
                  <td><input id="joint_mailing_address_line_1" type="text" v-model="this.funding_data.joint.mailing_address.mailing_address_line_1"/></td>
                </tr>
                <tr>
                  <td>joint_mailing_address_line_2</td>
                  <td><input id="joint_mailing_address_line_2" type="text" v-model="this.funding_data.joint.mailing_address.mailing_address_line_2"/></td>
                </tr>
                <tr>
                  <td>joint_mailing_city</td>
                  <td><input id="joint_mailing_city" type="text" v-model="this.funding_data.joint.mailing_address.mailing_city"/></td>
                </tr>
                <tr>
                  <td>joint_mailing_zip</td>
                  <td><input id="joint_mailing_zip" type="text" v-model="this.funding_data.joint.mailing_address.mailing_zip"/></td>
                </tr>
                <tr>
                  <td>joint_mailing_state</td>
                  <td><input id="joint_mailing_state" type="text" v-model="this.funding_data.joint.mailing_address.mailing_state"/></td>
                </tr>
                <tr>
                  <td class="note" colspan="2">Note: Zipcode must be a real zipcode that correctly matches the city and state.</td>
                </tr>
                <tr>
                  <button type="button" class="next-button" title="copy primary to mailing" @click="copyJointToMailing()">
                    Copy Joint Address to Mailing
                  </button>
                </tr>
                <div class="v-spacer-20"/>
                <tr>
                  <td>joint_identification_type</td>
                  <td><input id="joint_identification_type" type="text" v-model="this.funding_data.joint.identification.type"/></td>
                </tr>
                <tr>
                  <td class="note" colspan="2">Note: ID Type must be one of the following: ["drivers_license", "state_id_card", "passport"]</td>
                </tr>
                <tr>
                  <td>joint_identification_location</td>
                  <td><input id="joint_identification_location" type="text" v-model="this.funding_data.joint.identification.location"/></td>
                </tr>
                <tr>
                  <td>joint_identification_issused_date</td>
                  <td><input id="joint_identification_issused_date" type="text" v-model="this.funding_data.joint.identification.issused_date"/></td>
                </tr>
                <tr>
                  <td>joint_identification_expiration_date</td>
                  <td><input id="joint_identification_expiration_date" type="text" v-model="this.funding_data.joint.identification.expiration_date"/></td>
                </tr>
                <tr>
                  <td>joint_identification_number</td>
                  <td><input id="joint_identification_number" type="text" v-model="this.funding_data.joint.identification.number"/></td>
                </tr>
                <tr>
                  <td>joint_ssn</td>
                  <td><input id="joint_ssn" type="text" v-model="this.funding_data.joint.ssn"/></td>
                </tr>
                <div class="v-spacer-20"/>
              </template>
            </table>
            <!-- Accounts -->
            <div class="v-spacer-20"/>
            <div class="sub-header">Opened Accounts</div>
            <template v-for="i in this.funding_data.accounts.length" :key="i">
              <label :for="`account-table-${i}`" >{{ `Account ${i}` }}</label>

              <table :id="`account-table-${i}`" class="account-table">
                <tr>
                  <td>product_type <span class="fhb-red"><strong>*</strong></span></td>
                  <td><input type="text" id="product_type" v-model="this.funding_data.accounts[i-1].product_type"/></td>
                </tr>
                <tr>
                  <td>account_type <span class="fhb-red"><strong>*</strong></span></td>
                  <td><input type="text" id="account_type" v-model="this.funding_data.accounts[i-1].account_type"/></td>
                </tr>
                <tr>
                  <td>order_checks</td>
                  <td><input class="checkbox" type="checkbox" id="order_checks" v-model="this.funding_data.accounts[i-1].order_checks"/><label for="order_checks">Yes</label></td>
                </tr>
                <tr>
                  <td>debit_card</td>                
                  <td><input class="checkbox" type="checkbox" id="debit_card" v-model="this.funding_data.accounts[i-1].debit_card"/><label for="debit_card">Yes</label></td>
                </tr>
                <tr>
                  <td>overdraft_opt_in</td>                
                  <td><input class="checkbox" type="checkbox" id="overdraft_opt_in" v-model="this.funding_data.accounts[i-1].overdraft_opt_in"/><label for="overdraft_opt_in">Yes</label></td>
                </tr>
                <tr>
                  <td>account_disclosures <span class="fhb-red"><strong>*</strong></span></td>                
                  <td><input class="checkbox" type="checkbox" id="account_disclosures" v-model="this.funding_data.accounts[i-1].account_disclosures"/><label for="account_disclosures">Yes</label></td>
                </tr>
                <tr v-if="this.funding_data.is_joint">
                  <td>joint_account_disclosures <span class="fhb-red"><strong>*</strong></span></td>                
                  <td><input class="checkbox" type="checkbox" id="joint_account_disclosures" v-model="this.funding_data.accounts[i-1].joint_account_disclosures"/><label for="joint_account_disclosures">Yes</label></td>
                </tr>
                <tr>
                  <td>account_id <span class="fhb-red"><strong>*</strong></span></td>                
                  <td><input type="text" id="account_id" v-model="this.funding_data.accounts[i-1].account_id"/></td>
                </tr>
                <tr>
                  <td class="note" colspan="2">Note: Account ID should be the <span>Product code</span> of the new account</td>
                </tr>
                <tr>
                  <td>branch_id <span class="fhb-red"><strong>*</strong></span></td>                
                  <td><input type="text" id="branch_id" v-model="this.funding_data.accounts[i-1].branch_id"/></td>
                </tr>
                <tr>
                  <td>deposit_amount</td>                
                  <td><input type="text" id="deposit_amount" v-model="this.funding_data.accounts[i-1].deposit_amount"/></td>
                </tr>
                <tr>
                  <td>cd_term</td>                
                  <td><input type="text" id="cd_term" v-model="this.funding_data.accounts[i-1].cd_term"/></td>
                </tr>
                <tr>
                  <td>term_indicator</td>                
                  <td><input type="text" id="term_indicator" v-model="this.funding_data.accounts[i-1].term_indicator"/></td>
                </tr> 
                <tr>
                  <button type="button" class="next-button" title="delete account" @click="deleteAccount(i-1)">
                    Delete Account {{ i }}
                  </button>
                </tr>
              </table>
            </template>
            <div class="button-container">
              <button v-if="!this.funding_flow_id" type="button" class="next-button" title="add account" @click="addAccount()">
                Add Account
              </button>
            </div>
            <div class="v-spacer-20"/>
            <hr>
            <div class="button-container" v-if="!this.funding_flow_id">
              <button type="submit" class="next-button" title="next button">
                Submit Data
              </button>
            </div>
          </form>
          <div class="v-spacer-30"/>
          <template v-if="this.created_accounts">
            <div class="sub-header">Accounts Created</div>
            <table class="account-numbers-table">
              <tr>
                <th>Account ID (code)</th>
                <th>Account Number</th>
              </tr>
              <tr v-for="i in this.created_accounts.length" v-bind:key="i">
                <td>{{ this.created_accounts[i-1].account_id }}</td>
                <td>{{ this.created_accounts[i-1].account_number }}</td>
              </tr>
            </table>
            <div class="sub-header">SSO Redirect</div>
            <table class="redirect-table">
              <tr>
                <th>Funding Flow ID</th>
                <th>{{ this.funding_flow_id }}</th>
              </tr>
              <tr>
                <th>SSN</th>
                <td>{{ this.funding_data.primary.ssn }}</td>
              </tr>
              <tr v-if="this.redirect_url">
                <th>Redirect URL</th>
                <td><a :href="this.redirect_url" target="_blank">{{ this.redirect_url }}</a></td>
              </tr>
              <div v-if="!this.redirect_url" class="v-spacer-20"/>
              <tr v-if="!this.redirect_url">
                <button type="button" class="next-button" title="get redirect" @click="getRedirect()">
                  Get Redirect URL
                </button>
              </tr>
            </table>
          </template>

        </template>
        <template v-else #form-content>
          <div class="sub-header">API Error: </div>
          <div>{{ this.api_err }}</div>
        </template>
      </FormContainer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormContainer from '@/components/FormContainer.vue'
import SplashBackground from '@/components/Splash.vue'
import api from '@/app/testing_api.js'
// import jQuery from 'jquery'

export default {
  name: 'MainPage',
  components: {
    FormContainer,
    SplashBackground
    // MoneyInput,
  },
  data() {
    return {
      api_err: "",
      funding_data: "",
      funding_flow_id: "",
      redirect_url: "",
      created_accounts: null,
    }
  },
  methods: {
    ...mapActions('fundnow', ['']),
    copyPrimaryToMailing() {
      this.funding_data.primary.mailing_address.mailing_address_line_1 = this.funding_data.primary.address.address_line_1
      this.funding_data.primary.mailing_address.mailing_address_line_2 = this.funding_data.primary.address.address_line_2
      this.funding_data.primary.mailing_address.mailing_city = this.funding_data.primary.address.city
      this.funding_data.primary.mailing_address.mailing_zip = this.funding_data.primary.address.zip
      this.funding_data.primary.mailing_address.mailing_state = this.funding_data.primary.address.state
    },
    copyJointToMailing() {
      this.funding_data.joint.mailing_address.mailing_address_line_1 = this.funding_data.joint.address.address_line_1
      this.funding_data.joint.mailing_address.mailing_address_line_2 = this.funding_data.joint.address.address_line_2
      this.funding_data.joint.mailing_address.mailing_city = this.funding_data.joint.address.city
      this.funding_data.joint.mailing_address.mailing_zip = this.funding_data.joint.address.zip
      this.funding_data.joint.mailing_address.mailing_state = this.funding_data.joint.address.state
    },
    addAccount() {
      this.funding_data.accounts.push({
        product_type: "pure_checking",
        account_type: "dda",
        order_checks: false,
        debit_card: false,
        overdraft_opt_in: false,
        account_disclosures: true,
        joint_account_disclosures: true,
        account_id: "025",
        branch_id: "61",
        deposit_amount: "0",
        cd_term: "",
        term_indicator: "M"
      })
    },
    deleteAccount(i) {
      this.funding_data.accounts.splice(i, 1)
    },
    formatPayload() {
      if (!this.funding_data.is_joint) {
        delete this.funding_data.joint
      }
      let payload = {
        data: this.funding_data
      }
      return payload
    },
    async submitFirstPage() {
      this.disableInputs()

      const payload = this.formatPayload()
      const resp = await api.createCustomerAccount(payload)
      console.log("submit response: ", resp)
      if (resp) {
        if (resp.data?.message == 'OK' && resp.data.response?.data?.funding_flow_id) {
          this.funding_flow_id = resp.data.response.data.funding_flow_id
          this.created_accounts = []
          for (let i in resp.data.response.data.accounts) {
            this.created_accounts.push({'account_id': resp.data.response.data.accounts[i].account_id, 'account_number': resp.data.response.data.accounts[i].account_number})
          }
        } else {
          if (resp.data.response?.errors) {
            try {
              this.api_err = `Error Occured: ${resp.data.response.errors[0].code}: ${resp.data.response.errors[0].message}`
            } catch {
              this.api_err = `Error Occured: ${resp.data.response.errors.code}: ${resp.data.response.errors.message}`
            }
          } else if (resp.data.response?.data?.errors) {
            try {
              this.api_err = `Error Occured: ${resp.data.response.data.errors[0].code}: ${resp.data.response.data.errors[0].message}`
            } catch {
              this.api_err = `Error Occured: ${resp.data.response.data.errors.code}: ${resp.data.response.data.errors.message}`
            }
          }
        }
      } else {
        this.api_err = "network error occured, no resp returned"
      }
    },
    async getRedirect() {
      const resp = await api.getRedirectURL(this.funding_flow_id, this.funding_data.primary.ssn)
      if (resp.data?.message == 'OK' && resp.data.response?.data?.url) {
        this.redirect_url = this.convertResponseURL(resp.data.response.data.url)
      }
      else this.api_err = `network error response: ${resp.value}`
    },
    convertResponseURL(url) {
      try {
        let currentUrlObj = new URL(window.location.href);
        let paramUrlObj = new URL(url);
        let path = paramUrlObj.pathname + paramUrlObj.search + paramUrlObj.hash;
        return `${currentUrlObj.protocol}//${currentUrlObj.host}${path}`;
      } catch (e) {
        console.error("Invalid URL", e);
        return null;
      }
    },
    generateUID() {
      // I generate the UID from two parts here 
      // to ensure the random number provide enough bits.
      var firstPart = (Math.random() * 46656) | 0;
      var secondPart = (Math.random() * 46656) | 0;
      firstPart = ("000" + firstPart.toString(36)).slice(-3);
      secondPart = ("000" + secondPart.toString(36)).slice(-3);
      return firstPart + secondPart;
    },
    loadDefaultData() {
      var unique_q2_id = this.generateUID()
      this.funding_data = {
        ip_address: "123.12.12.12",
        user_agent: "mozilla",
        offer_code: "",
        utm_campaign: "test",
        utm_medium: "test",
        utm_source: "test",
        utm_term: "test",
        utm_content: "test",
        socure_id: "1234",
        socure_score: "10",
        qualifile_date: "test",
        primary: {
          first_name: "ANDREY",
          last_name: "IIRIS",
          middle_name: "",
          email_address: "",
          birthdate: "1989-01-01",
          mothers_maiden_name: "mom",
          employment_state: "employed",
          occupation: "banker",
          account_purpose: "income/salary",
          wealth_source: "employment",
          mobile_phone: "3052070010",
          ssn: "999211010",
          approved_account_disclosures: true,
          address: {
            address_line_1: "11308 SW 57th St",
            address_line_2: "",
            city: "MIAMI",
            zip: "33173",
            state: "FL",
          },
          mailing_address: {
            mailing_address_line_1: "11308 SW 57th St",
            mailing_address_line_2: "",
            mailing_city: "MIAMI",
            mailing_zip: "33173",
            mailing_state: "FL",
          },
          identification: {
            type: "drivers_license",
            location: "FL",
            issued_date: "2020-10-10",
            expiration_date: "2028-12-28",
            number: "F210000000565",
          },
        },
        joint: {
          first_name: "john",
          last_name: "doe",
          middle_name: "m",
          email_address: "test@email.com",
          birthdate: "01/02/2000",
          mothers_maiden_name: "mom",
          employment_state: "employed",
          occupation: "banker",
          account_purpose: "pleasure",
          wealth_source: "job",
          mobile_phone: "+18085551234",
          ssn: "123456789",
          approved_account_disclosures: true,
          address: {
            address_line_1: "123 main",
            address_line_2: "",
            city: "SUNNYVALE",
            zip: "940871930",
            state: "CA",
          },
          mailing_address: {
            mailing_address_line_1: "123 second",
            mailing_address_line_2: "",
            mailing_city: "SUNNYVALE",
            mailing_zip: "940871930",
            mailing_state: "CA",
          },
          identification: {
            type: "drivers_license",
            location: "HI",
            issued_date: "2020-10-10",
            expiration_date: "2028-12-28",
            number: "987654321",
          },
        },
        is_joint: false,
        //we extract suffix name, backup withholding, and w9 tax certification from this field
        unstructured_vars: "{\"mothersMaidenNameApp2\":\"test\",\"ssn3App2\":\"null\",\"isReturningUser\":\"true\",\"country\":\"\",\"referApplicationPageFlag\":\"false\",\"mobileCarrier\":\"\",\"isValidSEG\":\"false\",\"isFundingBalanceVerified\":\"undefined\",\"applicants\":\"\\\"{\\\\\\\"1\\\\\\\":{\\\\\\\"lastName\\\\\\\":\\\\\\\"Donald\\\\\\\",\\\\\\\"firstName\\\\\\\":\\\\\\\"Andy\\\\\\\",\\\\\\\"isExistingApplicantFound\\\\\\\":\\\\\\\"false\\\\\\\",\\\\\\\"mailAddrStateAddr\\\\\\\":\\\\\\\"\\\\\\\",\\\\\\\"existingCustomerSignal\\\\\\\":\\\\\\\"continue\\\\\\\",\\\\\\\"suffix\\\\\\\":\\\\\\\"Sr\\\\\\\"},\\\\\\\"2\\\\\\\":{\\\\\\\"zip\\\\\\\":\\\\\\\"96813\\\\\\\",\\\\\\\"lastName\\\\\\\":\\\\\\\"Rose\\\\\\\",\\\\\\\"city\\\\\\\":\\\\\\\"Honolulu\\\\\\\",\\\\\\\"Addr2DivApp2\\\\\\\":\\\\\\\"false\\\\\\\",\\\\\\\"isExistingApplicantFound\\\\\\\":\\\\\\\"false\\\\\\\",\\\\\\\"secondAddress\\\\\\\":\\\\\\\"\\\\\\\",\\\\\\\"mailAddrStateAddr\\\\\\\":\\\\\\\"\\\\\\\",\\\\\\\"suffix\\\\\\\":\\\\\\\"Jr\\\\\\\",\\\\\\\"firstName\\\\\\\":\\\\\\\"Lily\\\\\\\",\\\\\\\"mobilePhone\\\\\\\":\\\\\\\"(808) 123-1234\\\\\\\",\\\\\\\"streetAddress\\\\\\\":\\\\\\\"123 Stret\\\\\\\",\\\\\\\"middleName\\\\\\\":\\\\\\\"\\\\\\\",\\\\\\\"existingCustomerSignal\\\\\\\":\\\\\\\"continue\\\\\\\",\\\\\\\"state\\\\\\\":\\\\\\\"HI\\\\\\\",\\\\\\\"email\\\\\\\":\\\\\\\"test@test.com\\\\\\\"}}\\\"\",\"sendApp2\":\"true\",\"suffix\":\"Sr\",\"occupancyDuration\":\"0\",\"nextButtonApp2Changed\":\"true\",\"nextButtonApp1Changed\":\"true\",\"isNative\":\"false\",\"cart\":\"[\\\"pure_checking\\\"]\",\"jointAccount\":\"true\",\"ssn3TxtFld\":\"true\",\"ssn3TxtFldApp2\":\"true\",\"isJointAuth\":\"false\",\"countryApp2\":\"\",\"idStateApp2\":\"HI\",\"tuDVSessionId\":\"38e192b8-aaae-475f-8b7b-cfcc55ecbaf4\",\"applicationStatusDateTime\":\"2024-04-08 22:27:44.785\",\"idTypeApp2\":\"driversLicense\",\"brand\":\"999999\",\"ssn2App2\":\"null\",\"cookie\":\"_ga=GA1.1.1135852820.1701426127; cookieDeviceInfo1=Mozilla/5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit/537.36%20(KHTML%2C%20like%20Gecko)%20Chrome/120.0.0.0%20Safari/537.36; _gcl_au=1.1.2083551822.1705475471; _uetvid=bbbf5f90824f11ed8d8479c10ce89f39; ajs_user_id=null; ajs_group_id=null; ajs_anonymous_id=%226e5fef83-925a-4c93-afeb-ffbc37591eb1%22; _pin_unauth=dWlkPU5UVTROR0kxTldFdE5XSXpNUzAwWTJZNExXRTRZMk10TkdFMlpHSTNNVEk0TmpFMw; MOTHERS_MAIDEN=true; SSN=true; _scid=d6d5af05-1f37-4659-9128-2798c90a7bdc; _sctr=1%7C1707458400000; _scid_r=d6d5af05-1f37-4659-9128-2798c90a7bdc; cookieDeviceInfo3=Mozilla/5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit/537.36%20(KHTML%2C%20like%20Gecko)%20Chrome/122.0.0.0%20Safari/537.36; SSN_APP2=true; cookieTimeoutDays3=30; cookieDeviceInfo2=Mozilla/5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit/537.36%20(KHTML%2C%20like%20Gecko)%20Chrome/122.0.0.0%20Safari/537.36; cookieTimeoutDays2=30; _gid=GA1.1.734098793.1712588507; _uetsid=ef419cc0f5b811ee9742f30d94dd47bb; _ga_VT68Y9LCDY=GS1.1.1712588511.106.1.1712588763.0.0.0; amp_51eeb5=m-xbAOl36UsSRcZ78oNkXk...1hqv3rasm.1hqv3vnc2.0.0.0; _ga_FZQL85BDCW=GS1.1.1712615081.79.0.1712615081.60.0.0\",\"ssn1TxtFld\":\"true\",\"productTypes\":\"[\\\"dda\\\"]\",\"mspApplicationId\":" + `"${unique_q2_id}"` + ",\"ssn1App2\":\"null\",\"ssn2TxtFldApp2\":\"true\",\"emailValidationOverriden\":\"false\",\"lastNameApp2\":\"Rose\",\"productIds\":\"[\\\"pure_checking\\\"]\",\"domain\":\"http://localhost:8080\",\"eSignTimeStamp\":\"1712615098227\",\"sentKBA\":\"true\",\"ssn3ConsTxtFld\":\"false\",\"idExpiresApp2\":\"02/02/2030\",\"idExpiresApp1\":\"01/01/2030\",\"suffixApp2\":\"Jr\",\"isFramework\":\"false\",\"birthDateApp2\":\"02/02/2001\",\"danalUsed\":\"false\",\"isOlbEnrolled\":\"false\",\"overdraft\":\"false\",\"OLBUserExists\":\"N\",\"authToken\":\"test\",\"willJoinCommunity\":\"false\",\"smsValidationOverriden\":\"false\",\"emailTxtFldApp2\":\"test@test.com\",\"isAuthenticated\":\"false\",\"ssn1TxtFldApp2\":\"true\",\"myRealIP\":\"123.123.12.12\",\"challengeKey\":\"challengeMothersMaiden\",\"ssn2TxtFld\":\"true\",\"disclosuresRead\":\"\\\"{\\\\\\\"PrivacyPolicy\\\\\\\":{\\\\\\\"clicked\\\\\\\":true,\\\\\\\"clickedTimeStamp\\\\\\\":1712615098230,\\\\\\\"read\\\\\\\":false,\\\\\\\"readTimeStamp\\\\\\\":null},\\\\\\\"eSignature\\\\\\\":{\\\\\\\"clicked\\\\\\\":true,\\\\\\\"clickedTimeStamp\\\\\\\":1712615098230,\\\\\\\"read\\\\\\\":true,\\\\\\\"readTimeStamp\\\\\\\":1712615097247},\\\\\\\"ElectronicTransactions\\\\\\\":{\\\\\\\"clicked\\\\\\\":true,\\\\\\\"clickedTimeStamp\\\\\\\":1712615301484,\\\\\\\"read\\\\\\\":false,\\\\\\\"readTimeStamp\\\\\\\":null,\\\\\\\"attachments\\\\\\\":[]},\\\\\\\"ElectronicTransactionsJoint\\\\\\\":{\\\\\\\"clicked\\\\\\\":true,\\\\\\\"clickedTimeStamp\\\\\\\":1712615303012,\\\\\\\"read\\\\\\\":false,\\\\\\\"readTimeStamp\\\\\\\":null}}\\\"\",\"products\":\"[\\\"\\\\\\\"{\\\\\\\\\\\\\\\"productId\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"pure_checking\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"productName\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"Pure Checking\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"productAmount\\\\\\\\\\\\\\\":0,\\\\\\\\\\\\\\\"isForFunding\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"true\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"productType\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"dda\\\\\\\\\\\\\\\"}\\\\\\\"\\\"]\",\"idNumApp2\":\"HI20230110\",\"carrierConsentId\":\"null\",\"isExistingCustomer\":\"false\",\"idIssueDateApp2\":\"02/02/2020\",\"idIssueDateApp1\":\"01/01/2020\",\"ssn2ConsTxtFld\":\"false\",\"totalApplicants\":\"2\",\"firstNameApp2\":\"Lily\",\"zipApp2\":\"96813\",\"productType\":\"dda\",\"remoteAddr\":\"0:0:0:0:0:0:0:1\",\"isCellphoneValidated\":\"false\",\"jointHasSameAddressAsPrimary\":\"true\",\"appAccountProducts\":\"[]\",\"empInitiatedAppThrough\":\"\",\"vouchedJSSDKInfo\":\"null\",\"custom\":\"\\\"\\\\\\\"[{\\\\\\\\\\\\\\\"employmentAndIncome\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"employmentStatusCustom\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"empStatusEmployedFullTime\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"occupationQ\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"occupation5\\\\\\\\\\\\\\\"}},\\\\\\\\\\\\\\\"purposeOfAccountQ\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"purpose2\\\\\\\\\\\\\\\"},\\\\\\\\\\\\\\\"sourceOfWealthQ\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"wealth1\\\\\\\\\\\\\\\"},\\\\\\\\\\\\\\\"backupWithholdingQ\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":false,\\\\\\\\\\\\\\\"backupWithholdingQFalse\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":true}}},\\\\\\\\\\\\\\\"name\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"employmentAndIncome\\\\\\\\\\\\\\\"},{\\\\\\\\\\\\\\\"employmentAndIncomeJoint\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"employmentStatusCustomJoint\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"empStatusEmployedFullTime\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"occupationQJoint\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"occupation5\\\\\\\\\\\\\\\"}}},\\\\\\\\\\\\\\\"name\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"employmentAndIncomeJoint\\\\\\\\\\\\\\\"},{\\\\\\\\\\\\\\\"pure_checking_checkDebitCardQuestions\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"pure_checking_wouldYouLikeToOrderChecks\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":false},\\\\\\\\\\\\\\\"pureChecking_wouldYouLikeADebitCard\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":true},\\\\\\\\\\\\\\\"pureChecking_wouldYouLikeADebitCardJoint\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":true},\\\\\\\\\\\\\\\"pureChecking_wouldYouLikeOverDraftTransfer\\\\\\\\\\\\\\\":{\\\\\\\\\\\\\\\"value\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"yesOptInOption\\\\\\\\\\\\\\\"}},\\\\\\\\\\\\\\\"name\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"pure_checking_checkDebitCardQuestions\\\\\\\\\\\\\\\"}]\\\\\\\"\\\"\",\"approvedEsignature\":\"true\",\"nextButtonValidateInfoChanged\":\"false\",\"userAgent\":\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36\",\"idState\":\"HI\",\"ssn1ConsTxtFld\":\"false\",\"smsValPk\":\"228\",\"correlationID\":\"null\",\"isValidScript\":\"true\",\"isExistingMemberWorkflow\":\"false\",\"isFundingSourceVerified\":\"undefined\",\"carrierAuthenticationKey\":\"null\"}",
        accounts: [
          {
            product_type: "pure_checking",
            account_type: "dda",
            order_checks: false,
            debit_card: false,
            overdraft_opt_in: false,
            account_disclosures: true,
            joint_account_disclosures: true,
            account_id: "025",
            branch_id: "61",
            deposit_amount: "0",
            cd_term: "",
            term_indicator: "M"
          }
        ]
      }
    },
    disableInputs() {
      var form = document.getElementById("create-funding-form");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }
    },  
  },
  computed: {
    ...mapGetters('fundnow', ['']),

  },
  created() {
    this.loadDefaultData()
  }
}
</script>
<style scoped lang="scss">
@import "./src/scss/_variables.scss";
@import "./src/scss/_mixins.scss";

form {
  margin-top: 30px;
}
.sub-header {
  font-size: 25px;
  font-weight: bold;
}
.account-table, .redirect-table, .account-numbers-table {
  td, th {
    text-align: left;
  }
  width: 75%;
  padding: 5px;
  border: 2px solid $gray;
  margin-bottom: 10px;
}
.account-numbers-table {
  th {
    border-bottom: 1px solid $gray
  }
  margin-bottom: 10px;
}
a {
  color: blue;
}

.next-button, .checkbox {
  :hover {
    cursor: pointer;
  }
}

.optional-text {
  font-style: italic;
}
.note {
  font-style: italic;
  color: $grayDark
}

.fhb-red {
  color: $redSup;
}
</style>
